import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { FormBuilder, FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { TextInputControl } from 'src/app/form-controls/text-input/text-input.control';
import { SheetActionControlsBase } from 'src/app/services/sheets-renderer.service';
import { Row, Slot } from 'src/app/types/aggregate-graph.types';
import { PainScoreExoticAction } from 'src/app/types/sheet-action-aggregate-graph.types';
import { ActionFormComponent } from '../../action-form/action-form.component';
import { CommonActionControlsComponent } from '../../common-action-controls/common-action-controls.component';
import { ActionAlertComponent } from '../../action-alert/action-alert.component';

interface PainScoreExoticActionFormGroup {
	score: FormControl<number | null>;
}

@Component({
    selector: 'app-pain-score-exotic-action-controls',
    templateUrl: './pain-score-exotic-action-controls.component.html',
    styleUrls: ['../../../common.scss', './pain-score-exotic-action-controls.component.scss'],
    imports: [ReactiveFormsModule, CommonActionControlsComponent, ActionFormComponent, TextInputControl, ActionAlertComponent],
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class PainScoreExoticActionControlsComponent implements SheetActionControlsBase, OnInit {

	slot!: Slot | null;
	action!: PainScoreExoticAction;

	@Input('slot') set updateSlot(slot: Slot | null) {
		this.slot = slot;
		this.action = slot?.action as PainScoreExoticAction;
	}

	@Input() form!: FormGroup<PainScoreExoticActionFormGroup>;
	@Input() item!: Row | null;
	
	constructor(private formBuilder: FormBuilder) {
	}

    ngOnInit(): void {
        this.form.addControl('score', this.formBuilder.control(this.action?.score ?? null));
    }
}